import { Grid } from "@mui/material"
import { CustomTabPanel } from "../../../../../components/componentsAnaliseClientes/CustomTabPanel"
import { TabNumberOfSalesCardItem } from "./item"

export const TabNumberOfSalesCards = ({ data, value }) => {

    return <CustomTabPanel value={value} index={0} style={{ padding: '16px' }}>
        <Grid container spacing={2}>
            <TabNumberOfSalesCardItem title="Ano Atual" data={data?.currentYear} />
            <TabNumberOfSalesCardItem title="Ano Anterior" data={data?.pastYear} />
            <TabNumberOfSalesCardItem title="Período anterior" data={data?.pastPeriod} />
        </Grid>
    </CustomTabPanel>
}